export enum Types {
  SET_OBSERVABILITY_INITIALIAZED = 'observalibity/SET_OBSERVABILITY_INITIALIAZED',
  SET_OBSERVABILITY_INITIALIAZED_SUCCESS = 'observalibity/SET_OBSERVABILITY_INITIALIAZED_SUCCESS',
  OBSERVABILITY_ERROR = 'observalibity/OBSERVABILITY_ERROR',
  OBSERVABILITY_RCA_SEND_LOGS = 'observalibity/RCA_SEND_LOGS'
}

export interface IObservalibilityState {
  initialized: boolean;
}
